import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'noComma',
})
export class NoCommaPipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    return value !== undefined && value !== null ? value.toString().replace(/,/g, '') : '';
  }
}
